import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FeatureFlagAccessModel,
  FeatureFlagCodes,
  FeatureFlagStatus,
  SingleItemResponse,
} from '@core/models';
import { ExternalPaymentState } from '@core/state/external';
import { environment } from '@rcsa-frontend/environments/environment';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalFeatureFlagsService {
  constructor(
    private externalPaymentState: ExternalPaymentState,
    private http: HttpClient
  ) {}

  public isFeatureFlagActive(code: FeatureFlagCodes): Observable<boolean> {
    const cachedFlag = this.externalPaymentState.snapshot.featureFlags[code];

    if (cachedFlag !== undefined) {
      return of(cachedFlag);
    }

    const url = `${
      environment.apiUrl
    }/v1/external/account/feature-flags-access/status/${code}/${
      this.externalPaymentState.getExternalPayment.collectionNotice?.school
        ?.id || ''
    }`;

    return this.http.get<SingleItemResponse<FeatureFlagAccessModel>>(url).pipe(
      map((response) => {
        const status = response.data.access.map((item) => item.status);
        const isActive =
          !status.includes(FeatureFlagStatus.INACTIVE) &&
          !status.includes(FeatureFlagStatus.MAINTENANCE);
        this.externalPaymentState.setFeatureFlag(code, isActive);
        return isActive;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }
}
